import { Component } from '@angular/core';

@Component({
  selector: 'dmpfooter',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
 
}
